<template>
  <div class="home">
    <div class="test" v-if="isSdkReady">
      <button @click="handleTest1">朋友别走</button>
      <button @click="handleTest2">友谊长存</button>
    </div>
  </div>
</template>

<script>
import {  isAndroid, isIOS } from '../utils'
import wx from 'weixin-js-sdk'
export default {
  name: 'Home',
  data: () => {
    return {
      isSdkReady: false,
    }
  },
  
  mounted(){
    wx.ready(() => { 
      this.isSdkReady = true
      console.log('ready - home')
      wx.updateAppMessageShareData({ 
        title: '朋友啊朋友',
        desc: '这是一条来自远方的新年祝福',
        link: 'https://dj-marketingtest1.abite.com/#/',
        imgUrl: 'https://dj-marketingtest1.abite.com/share.png',
        success: function () {
          console.log('设置朋友成功')
        }
      })

      wx.updateTimelineShareData({ 
        title: '这是一条来自远方的新年祝福',
        link: 'https://dj-marketingtest1.abite.com/#/',
        imgUrl: 'https://dj-marketingtest1.abite.com/share.png',
        success: function () {
          console.log('设置朋友圈成功')
        }
      })

      // wx.onMenuShareWechat({
      //     title: '这22', // 分享标题
      //       desc: '这是一条来自远方的新年祝福',
      //     link: 'https://dj-marketingtest1.abite.com/#/',
      //     imgUrl: 'https://dj-marketingtest1.abite.com/share.png',
      //     success: function () {
      //       console.log(1)
      //         // 用户确认分享后执行的回调函数
      //     },
      //     cancel: function () {
      //       console.log(2)
      //         // 用户取消分享后执行的回调函数
      //     }
      // });

    }); 
  },
  methods:{
    handleTest1(){

    },
    handleTest2(){

    }
  }
}
</script>

<style scoped lang="scss">
.home{
  width: 750px;
}
</style>
